export const shoes = {
  "shoe-1": {
    modelUrl: "shoe-draco.glb",
    thumbnailUrl: "/images/shoe-1.png",
    components: {
      laces: {
        geometry: "shoe.geometry",
      },
      mesh: {
        geometry: "shoe_1.geometry",
      },
      caps: {
        geometry: "shoe_2.geometry",
      },
      inner: {
        geometry: "shoe_3.geometry",
      },
      sole: {
        geometry: "shoe_4.geometry",
      },
      stripes: {
        geometry: "shoe_5.geometry",
      },
      band: {
        geometry: "shoe_6.geometry",
      },
      patch: {
        geometry: "shoe_7.geometry",
      },
    },
  },
  "shoe-2": {
    modelUrl: "nike-air-force-1-draco.glb",
    thumbnailUrl: "/images/shoe-2.png",
    components: {
      laces: {
        geometry: "Shoe004.geometry",
      },
      mesh: {
        geometry: "Shoe.geometry",
      },
      inner: {
        geometry: "Shoe001.geometry",
      },
      sole: {
        geometry: "Shoe002.geometry",
      },
      stripes: {
        geometry: "Shoe003.geometry",
      },
    },
  },
};
